import { Box, Typography } from "@mui/material";
import MyChip from "../common";
import RightBarImgList from "./rightbarImgList";
import RightRecommend from "./rightRecommend";
import { useState } from "react";
import SearchDialog from "../appDialog";

export default function RightBar({matches}){
    const [openSearch, setOpenSearch] = useState(false)
    const [chipTitle, setChipTitle] = useState(null)

    return(
        <Box flex={2} p={2}   >
            <SearchDialog 
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
                chipTitle={chipTitle}
            />
            <Box position="fixed" variant="h6" fontWeight={100} width={300}>
                <Typography p={2}>热门主题排行</Typography>
                <MyChip setOpenSearch={setOpenSearch} setChipTitle={setChipTitle}/>
                <Typography p={2}>夜未央夫妻作品</Typography>
                <Box sx={{maxHeight: 600, overflow: 'auto'}}>
                <RightBarImgList matches={matches}/>
                <Typography p={1} mt={3}>每日店长推荐作品</Typography>
                <RightRecommend matches={matches} setOpenSearch={setOpenSearch} setChipTitle={setChipTitle}/>
                </Box>
            </Box>
        </Box>
    )
}